class AISearchManager {
	constructor() {
		this.isLoading = false;

		this.responseText = "";
		this.products = [];
		this.allProductIds = []; // Store all product IDs
		this.displayedCount = 0; // Track how many products are displayed
		this.pageSize = 20; // Number of products to load per batch
		this.lastSearchQuery = null; // Store the last search query for contact form
	}

	initialize(searchContainer, query) {
		this.userId = web.visitor.id;
		this.sessionId = this.new_session_id();
		this.serarchContainer = searchContainer;
		this.aiIcon = this.serarchContainer.find("#ai-icon");
		this.searchInput = this.serarchContainer.find("#search-input");
		this.sendButton = this.serarchContainer.find("#send-button");
		this.applyFilterButton = this.serarchContainer.find(".apply-filter-button");

		this.aiContainer = this.serarchContainer.find("#ai-response-container");
		this.newButton = this.aiContainer.find("#new-button");
		this.newButton2 = this.aiContainer.find("#new-button2");

		this.resultsContainer = this.serarchContainer.find("#results-container");
		this.historyContainer = this.resultsContainer.find("#history-container");
		this.productsContainer = this.resultsContainer.find("#products-container");

		this.loadMoreContainer = this.resultsContainer.find("#load-more-container");
		this.loadMoreButton = this.loadMoreContainer.find("#load-more-button");
		this.scrollTopButton = this.loadMoreContainer.find("#scroll-top-button");
		this.loadMoreButtonOriginalText = this.loadMoreButton.html();

		this.query = query;

		this.searchInput.on('keypress', (e) => {
			if (e.which === 13 && !e.shiftKey) {
				e.preventDefault();
				this.performSearch();
			}
		});

		this.sendButton.on('click', () => this.performSearch());

		this.newButton.on('click', () => this.startNewSession());
		this.newButton2.on('click', () => this.startNewSession());

		this.applyFilterButton.on('click', () => this.performSearch());

		// Reset filters button
		$('#reset-filters-button').on('click', () => this.resetFilters());

		// Initialize load more container (hide initially)
		this.loadMoreContainer.addClass('d-none');
		this.loadMoreButton.on('click', () => this.loadMoreProducts());
		this.scrollTopButton.on('click', () => this.scrollTop());

	}

	scrollTop() {
		$("html, body").animate({
			scrollTop: 0
		}, 500);
	}

	new_session_id() {
		return "web_search" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
	};

	startNewSession() {
		// Generate new session ID
		this.sessionId = this.new_session_id();

		// Clear the search input
		this.searchInput.val('');

		// Clear AI response
		this.aiContainer.addClass('d-none');

		// Clear products display
		this.productsContainer.html('');

		// Reset response text
		this.responseText = "";
		this.products = [];
		this.allProductIds = [];
		this.displayedCount = 0;

		// Hide load more container
		this.loadMoreContainer.addClass('d-none');

		// Reset all filter selections
		this.resetFilters();

		// Focus on search input
		this.searchInput.focus();
	}

	setLoading(loading) {
		this.isLoading = loading;

		if (loading) {
			this.sendButton.prop('disabled', true);
			this.searchInput.prop('disabled', true);
			this.aiIcon.addClass('spin');
		} else {
			this.sendButton.prop('disabled', false);
			this.searchInput.prop('disabled', false);
			this.searchInput.focus();
			this.aiIcon.removeClass('spin');
		}
	}

	async performSearch() {
		if (this.isLoading) return;

		// Get search text from input
		const searchText = this.searchInput.val().trim();

		// Collect filter data
		const filterData = this.collectFilterData();

		// Get sort preference
		const sortLabel = $("#search-part #sort-menu #sort-label").text().trim();
		const sortMessage = sortLabel ? `Sıralama: ${sortLabel}` : '';

		// Build message combining search text and filters
		let message = searchText;
		const filterMessage = this.buildFilterMessage(filterData);

		// Combine search text with filter message and sort
		if (searchText && filterMessage) {
			message = `${searchText}. ${filterMessage}`;
		} else if (!searchText && filterMessage) {
			message = filterMessage;
		} else if (!searchText && !filterMessage && !sortMessage) {
			// No search text, no filters, and no sort change - don't search
			return;
		} else if (!searchText && !filterMessage && sortMessage) {
			// Only sort is specified
			message = sortMessage;
		}

		// Add sort preference to the message if we have other criteria
		if (sortMessage && (searchText || filterMessage)) {
			message = `${message}. ${sortMessage}`;
		}

		this.setLoading(true);

		// Reset pagination for new search
		this.allProductIds = [];
		this.displayedCount = 0;
		this.productsContainer.html('');
		this.loadMoreContainer.addClass('d-none');

		try {
			const response = await fetch('/functions/n8n.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action: 'product_search',
					message: message,
					filters: filterData,
					user_id: this.userId,
					session_id: this.sessionId,
				})
			});

			const result = await response.json();

			if (result.success && result.response) {
				this.responseText = result.response.text || "";
				this.products = result.response.products || [];
				this.total_found = result.response.total_found || 0;
				this.collect_contact = result.response.collect_contact || false;
				this.no_results = result.response.no_results || false;

				// Store the last search query for contact form
				this.lastSearchQuery = {
					message: message,
					filters: filterData,
					timestamp: new Date().toLocaleString()
				};

				// Store all product IDs
				this.allProductIds = this.products.map(p => p.id);

				this.displayMessage(this.responseText, this.total_found, result.message);

				// If no results, show contact form
				if (this.no_results) {
					this.showContactForm();
				} else {
					// Load first batch of products
					await this.loadMoreProducts(true);
				}
			} else {
				this.displayMessage(web.labels.operation_not_completed, 0);
				this.displayProducts("");
			}
		} catch (error) {
			this.displayMessage(web.labels.operation_not_completed);
		} finally {
			this.setLoading(false);
		}
	}

	displayMessage(message, total_found = 0, last_query = "") {
		if (total_found > 0) {
			this.aiContainer.find("#no-products-found").addClass('d-none')
			this.messageContainer = this.aiContainer.find("#products-found");
			this.messageContainer.removeClass('d-none');
			this.messageContainer.find("#message").text(message);
			this.messageContainer.find("#total-found").text(total_found);
		}
		else {
			this.aiContainer.find("#products-found").addClass('d-none');
			this.messageContainer = this.aiContainer.find("#no-products-found");
			const cleanedQuery = last_query.replace(/<[^>]*>/g, '');
			this.messageContainer.find("#content").text(cleanedQuery);
			this.messageContainer.removeClass('d-none');
		}
		this.aiContainer.removeClass('d-none').addClass('d-flex');
		this.searchInput.val('').focus();
	}

	showContactForm() {
		const $form = this.aiContainer.find("#contact-form-container");
		$form.removeClass('d-none');

		$form.find("#submit-button").off('click').on('click', (e) => {
			e.preventDefault();
			this.submitContactForm();
		});
	}

	async submitContactForm() {
		const $form = this.aiContainer.find("#contact-form-container");

		const token = await grecaptcha.enterprise.execute(web.captcha_key, {
			action: 'LOGIN'
		});
		if (token) {
			let data = {};
			data.token = token;
			data.form_category_id = 9;
			data.product_id = 0;
			data.user_id = 0;
			data.first_name = $form.find("#first-name").val();
			data.last_name = $form.find("#last-name").val();
			data.email = $form.find("#email").val();
			data.phone = $form.find("#phone").val();;
			data.content = $form.find("#content").val();
			data.settings = [
				{ key: "query", value: this.lastSearchQuery.message },
				{ key: "user_id", value: this.userId },
				{ key: "session_id", value: this.sessionId }
			];

			if (data.first_name == "" || data.last_name == "" || (data.email == "" && data.phone == "")) {
				web.error_message();
				return
			}
			web.post("common", {
				action: "send_form",
				data: data
			}, function (result, data) {
				if (result == 1 && data.id > 0) {
					web.display_message("success", web.labels.operation_completed);
				}
			});
		}
	}

	buildHumanReadableQuery() {
		if (!this.lastSearchQuery) return '';

		let queryText = this.lastSearchQuery.message;
		queryText += '\n\nTimestamp: ' + this.lastSearchQuery.timestamp;

		return queryText;
	}

	async loadMoreProducts(isFirstLoad = false) {
		// Don't check loading state on first load since parent already set it
		if (!isFirstLoad && this.isLoading) return;

		// Calculate which products to fetch
		const startIndex = this.displayedCount;
		const endIndex = Math.min(startIndex + this.pageSize, this.allProductIds.length);
		const productIdsToFetch = this.allProductIds.slice(startIndex, endIndex);

		if (productIdsToFetch.length === 0) return;

		// Create and show loading animation
		const $loadingPlaceholder = $(`
			<div class="loading-placeholder text-center py-5">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
				<div class="mt-3 text-muted text-uppercase">${web.labels.loading}</div>
			</div>
		`);
		this.productsContainer.append($loadingPlaceholder);

		if (!isFirstLoad) {
			this.setLoading(true);
			// Disable and show loading state on load-more button
			this.loadMoreButton.prop('disabled', true);
		}

		try {
			const response = await fetch('/functions/n8n.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action: 'fetch_products',
					product_ids: productIdsToFetch,
					session_id: this.sessionId,
				})
			}); const result = await response.json();

			// Remove loading placeholder
			$loadingPlaceholder.remove();

			if (result.products_html) {
				this.productsContainer.append(result.products_html);
				this.displayedCount = endIndex;
				this.messageContainer.find("#returned-count").text(this.displayedCount);
				if (this.displayedCount < this.allProductIds.length && this.allProductIds.length > 12) {
					this.loadMoreContainer.removeClass('d-none').addClass('d-flex');
				} else {
					this.loadMoreContainer.addClass('d-none').removeClass('d-flex');
				}
				setTimeout(() => {
					this.productsContainer.find('.product-item').addClass("loaded");
				}, 100);
			}
		} catch (error) {
			console.error('Error loading products:', error);
			$loadingPlaceholder.remove();
		} finally {
			if (!isFirstLoad) {
				this.setLoading(false);
				// Re-enable and restore original text on load-more button
				this.loadMoreButton.prop('disabled', false);
			}
		}
	}

	displayProducts(productsHtml) {
		this.productsContainer.html(productsHtml);
		setTimeout(() => {
			this.productsContainer.find('.product-item').addClass("loaded");
		}, 100);
	}

	escapeHtml(text) {
		const div = document.createElement('div');
		div.textContent = text;
		return div.innerHTML;
	}

	collectFilterData() {
		const filterData = {
			main_group_ids: [],
			transaction_type_ids: [],
			sub_group_ids: [],
			city_ids: [],
			town_ids: [],
			quarter_ids: [],
			price: { min: 0, max: 0, currency: 1 },
			area: { min: 0, max: 0 },
			room_type_ids: [],
			commercial_room_type_ids: [],
			bathrooms: [],
			bathroom_parent: 0,
			is_eids_verified: 0,
			is_auction: 0
		};

		// Main groups
		$("#search-part [data-main-group-id]:checked").each(function () {
			filterData.main_group_ids.push($(this).attr("data-main-group-id"));
		});

		// Transaction types
		$("#search-part [data-transaction-type-id]:checked").each(function () {
			filterData.transaction_type_ids.push($(this).attr("data-transaction-type-id"));
		});

		// Sub groups
		filterData.sub_group_ids = $("#search-part #sub-groups").val() || [];

		// Locations
		filterData.city_ids = $("#search-part #cities").val() || [];
		filterData.town_ids = $("#search-part #towns").val() || [];
		filterData.quarter_ids = $("#search-part #quarters").val() || [];

		// Price (accessing AutoNumeric instances)
		if (typeof price_min !== 'undefined' && price_min.rawValue > 0) {
			filterData.price.min = price_min.rawValue;
		}
		if (typeof price_max !== 'undefined' && price_max.rawValue > 0) {
			filterData.price.max = price_max.rawValue;
		}

		// Area (accessing AutoNumeric instances)
		if (typeof area_min !== 'undefined' && area_min.rawValue > 0) {
			filterData.area.min = area_min.rawValue;
		}
		if (typeof area_max !== 'undefined' && area_max.rawValue > 0) {
			filterData.area.max = area_max.rawValue;
		}

		// Rooms
		filterData.room_type_ids = $("#search-part #rooms").val() || [];
		filterData.commercial_room_type_ids = $("#search-part #commercial-rooms").val() || [];
		filterData.bathrooms = $("#search-part #bathrooms").val() || [];

		// Bathroom parent
		if ($("#search-part #bathroom-parent").prop("checked")) {
			filterData.bathroom_parent = 1;
		}

		// EIDS verified
		if ($("#search-part #is-eids-verified").prop("checked")) {
			filterData.is_eids_verified = 1;
		}

		// Auction
		if ($("#search-part #is-auction").prop("checked")) {
			filterData.is_auction = 1;
		}

		return filterData;
	}

	// Helper function to capitalize and wrap in bold tags
	capitalizeAndBold(text) {
		return `<b>${text.charAt(0).toUpperCase() + text.slice(1)}</b>`;
	}

	buildFilterMessage(filterData) {
		const parts = [];

		// Main groups - read label text from UI
		if (filterData.main_group_ids.length > 0) {
			const mainGroupNames = [];
			filterData.main_group_ids.forEach(id => {
				const label = $(`#search-part [data-main-group-id="${id}"]`).next('label').text().trim();
				if (label) mainGroupNames.push(this.capitalizeAndBold(label));
			});
			if (mainGroupNames.length > 0) {
				parts.push(`Ana grubu ${mainGroupNames.join(', ')} olan`);
			}
		}

		// Transaction types - read label text from UI
		if (filterData.transaction_type_ids.length > 0) {
			const transactionTypeNames = [];
			filterData.transaction_type_ids.forEach(id => {
				const label = $(`#search-part [data-transaction-type-id="${id}"]`).next('label').text().trim();
				if (label) transactionTypeNames.push(this.capitalizeAndBold(label));
			});
			if (transactionTypeNames.length > 0) {
				parts.push(`İşlem tipi ${transactionTypeNames.join(', ')} olan`);
			}
		}

		// Sub groups - read selected option text from multiselect
		if (filterData.sub_group_ids.length > 0) {
			const subGroupNames = [];
			filterData.sub_group_ids.forEach(id => {
				const optionText = $(`#search-part #sub-groups option[value="${id}"]`).text().trim();
				if (optionText) subGroupNames.push(this.capitalizeAndBold(optionText));
			});
			if (subGroupNames.length > 0) {
				parts.push(`Gayrimenkul tipi ${subGroupNames.join(', ')} olan`);
			}
		}

		// Cities - read selected option text
		if (filterData.city_ids.length > 0) {
			const cityNames = [];
			filterData.city_ids.forEach(id => {
				const optionText = $(`#search-part #cities option[value="${id}"]`).text().trim();
				if (optionText) cityNames.push(this.capitalizeAndBold(optionText));
			});
			if (cityNames.length > 0) {
				parts.push(`${cityNames.join(', ')} şehrinde`);
			}
		}

		// Towns - read selected option text
		if (filterData.town_ids.length > 0) {
			const townNames = [];
			filterData.town_ids.forEach(id => {
				const optionText = $(`#search-part #towns option[value="${id}"]`).text().trim();
				if (optionText) townNames.push(this.capitalizeAndBold(optionText));
			});
			if (townNames.length > 0) {
				parts.push(`${townNames.join(', ')} ilçesinde`);
			}
		}

		// Quarters - read selected option text
		if (filterData.quarter_ids.length > 0) {
			const quarterNames = [];
			filterData.quarter_ids.forEach(id => {
				const optionText = $(`#search-part #quarters option[value="${id}"]`).text().trim();
				if (optionText) quarterNames.push(this.capitalizeAndBold(optionText));
			});
			if (quarterNames.length > 0) {
				parts.push(`${quarterNames.join(', ')} semtinde`);
			}
		}

		// Price range
		if (filterData.price.min > 0 || filterData.price.max > 0) {
			if (filterData.price.min > 0 && filterData.price.max > 0) {
				parts.push(`Fiyat aralığı <b>${filterData.price.min.toLocaleString()}</b> - <b>${filterData.price.max.toLocaleString()}</b> TL olan`);
			} else if (filterData.price.min > 0) {
				parts.push(`Fiyatı en az <b>${filterData.price.min.toLocaleString()}</b> TL olan`);
			} else if (filterData.price.max > 0) {
				parts.push(`Fiyatı en çok <b>${filterData.price.max.toLocaleString()}</b> TL olan`);
			}
		}

		// Area range
		if (filterData.area.min > 0 || filterData.area.max > 0) {
			if (filterData.area.min > 0 && filterData.area.max > 0) {
				parts.push(`Alan <b>${filterData.area.min}</b> - <b>${filterData.area.max}</b> m² olan`);
			} else if (filterData.area.min > 0) {
				parts.push(`Alanı en az <b>${filterData.area.min}</b> m² olan`);
			} else if (filterData.area.max > 0) {
				parts.push(`Alanı en çok <b>${filterData.area.max}</b> m² olan`);
			}
		}

		// Room types - read selected option text
		if (filterData.room_type_ids.length > 0) {
			const roomNames = [];
			filterData.room_type_ids.forEach(id => {
				const optionText = $(`#search-part #rooms option[value="${id}"]`).text().trim();
				if (optionText) roomNames.push(this.capitalizeAndBold(optionText));
			});
			if (roomNames.length > 0) {
				parts.push(`Oda sayısı ${roomNames.join(', ')} olan`);
			}
		}

		// Commercial room types - read selected option text
		if (filterData.commercial_room_type_ids.length > 0) {
			const commercialRoomNames = [];
			filterData.commercial_room_type_ids.forEach(id => {
				const optionText = $(`#search-part #commercial-rooms option[value="${id}"]`).text().trim();
				if (optionText) commercialRoomNames.push(this.capitalizeAndBold(optionText));
			});
			if (commercialRoomNames.length > 0) {
				parts.push(`Bölüm sayısı ${commercialRoomNames.join(', ')} olan`);
			}
		}

		// Bathrooms - read selected option text
		if (filterData.bathrooms.length > 0) {
			const bathroomNames = [];
			filterData.bathrooms.forEach(id => {
				const optionText = $(`#search-part #bathrooms option[value="${id}"]`).text().trim();
				if (optionText) bathroomNames.push(this.capitalizeAndBold(optionText));
			});
			if (bathroomNames.length > 0) {
				parts.push(`Banyo sayısı ${bathroomNames.join(', ')} olan`);
			}
		}

		// Bathroom parent
		if (filterData.bathroom_parent) {
			parts.push('<b>Ebeveyn banyosu</b> olan');
		}

		// EIDS verified - read label text
		if (filterData.is_eids_verified) {
			const label = $("#search-part #is-eids-verified").next('label').text().trim();
			if (label) parts.push(this.capitalizeAndBold(label));
		}

		// Auction - read label text
		if (filterData.is_auction) {
			const label = $("#search-part #is-auction").next('label').text().trim();
			if (label) parts.push(this.capitalizeAndBold(label));
		}

		return parts.length > 0 ? parts.join(', ') : '';
	}

	resetFilters() {
		// Uncheck all checkboxes
		$("#search-part [data-main-group-id]").prop("checked", false);
		$("#search-part [data-transaction-type-id]").prop("checked", false);
		$("#search-part #bathroom-parent").prop("checked", false);
		$("#search-part #is-eids-verified").prop("checked", false);
		$("#search-part #is-auction").prop("checked", false);

		// Clear multiselects
		$("#search-part #sub-groups").val([]).multiselect('rebuild');
		$("#search-part #cities").val([]).multiselect('rebuild');
		$("#search-part #towns").val([]).multiselect('rebuild');
		$("#search-part #quarters").val([]).multiselect('rebuild');
		$("#search-part #rooms").val([]).multiselect('rebuild');
		$("#search-part #commercial-rooms").val([]).multiselect('rebuild');
		$("#search-part #bathrooms").val([]).multiselect('rebuild');

		// Clear price and area inputs
		if (typeof price_min !== 'undefined') price_min.set('');
		if (typeof price_max !== 'undefined') price_max.set('');
		if (typeof area_min !== 'undefined') area_min.set('');
		if (typeof area_max !== 'undefined') area_max.set('');
	}
}
